module.exports = __webpack_public_path__ + "static/img/application2-2.55512d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application2-2.jpg
// module id = RYkq
// module chunks = 0